import {createSelector} from 'reselect';

const getSessionUser = state =>
	state.session && state.session.current && state.session.current.user;

/**
 * The current user is logged in and they have set their first and last names.
 */
export const sessionUserIsIdentifiable = state =>
	userIsIdentifiable(state.session && state.session.current && state.session.current.user);

/**
 * The (optionally) supplied user has set their first and last names.
 */
export const userIsIdentifiable = user => user && user.firstname && user.lastname;

export const isSessionUserSystemAdmin = createSelector(
	getSessionUser,
	sessionUser => !!(sessionUser && sessionUser.admin)
);



// WEBPACK FOOTER //
// ./src/user/session.selectors.js